import PropTypes from 'prop-types';
import { STUDENT, STAFF, EDUCATOR } from '$variables/constants';

export const GradeType = PropTypes.shape({
  studentId: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  grade: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  avatar: PropTypes.string,
  hasSubmission: PropTypes.bool,
  lateSubmission: PropTypes.bool,
});

export const mappedAssignments = PropTypes.shape({
  id: PropTypes.string.isRequired,
});

const successfulStudentJob = PropTypes.shape({
  studentId: PropTypes.string,
  response: PropTypes.string,
});

const failedStudentJob = PropTypes.shape({
  studentId: PropTypes.string,
  error: PropTypes.string,
  domain: PropTypes.string,
  rawErrorMessage: PropTypes.string,
});

export const exportJobEventResults = PropTypes.shape({
  grades: PropTypes.shape({
    success: PropTypes.arrayOf(successfulStudentJob),
    errors: PropTypes.arrayOf(failedStudentJob),
  }),
});

export const LastEvent = PropTypes.shape({
  status: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
});

export const LastJob = PropTypes.shape({
  id: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  educator: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  grades: PropTypes.arrayOf(GradeType),
  lastEvent: LastEvent,
});

export const StudentGrade = PropTypes.shape({
  id: PropTypes.string,
  email: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  fullName: PropTypes.string,
  avatar: PropTypes.string,
  grade: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  displayGrade: PropTypes.string,
});

export const AssessmentItem = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  mappedAssignments: PropTypes.arrayOf(mappedAssignments),
  lastJob: LastJob,
  studentGrade: StudentGrade,
});

export const ErrorType = PropTypes.shape({
  message: PropTypes.string,
});

export const User = PropTypes.shape({
  id: PropTypes.string,
  roles: PropTypes.arrayOf(PropTypes.string),
  email: PropTypes.string,
  username: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  fullName: PropTypes.string,
  avatar: PropTypes.string,
});

export const Space = PropTypes.shape({
  id: PropTypes.string,
  avatar: PropTypes.string,
  code: PropTypes.string,
  name: PropTypes.string,
});

export const Assignment = PropTypes.shape({
  id: PropTypes.string.isRequired,
  externalId: PropTypes.string,
  provider: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  space: PropTypes.string.isRequired,
  gradesReleasedAt: PropTypes.string,
  gradeType: PropTypes.string,
  isAnonymised: PropTypes.bool,
  studentGrade: StudentGrade,
});

export const LtiProvider = PropTypes.shape({
  id: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  iconUrl: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
});

export const ViewAs = PropTypes.oneOf([STAFF, STUDENT, EDUCATOR]);
